var map = {
	"./Candy.webp": "ef29",
	"./Flamingo.webp": "e09d",
	"./Gas.webp": "46a1",
	"./GasbotFAQ.webp": "b0f4",
	"./GasbotHeader.webp": "65f8",
	"./GasbotIcon.svg": "3b40",
	"./GasbotSideLeft.webp": "61fd",
	"./GasbotSideRight.webp": "dbd1",
	"./GasbotSideTop.webp": "8c4a",
	"./GasbotSideTopDiscordLogos.webp": "3b408",
	"./GasbotSideTopRobot.webp": "74cd",
	"./Gm.webp": "6c127",
	"./Nep.webp": "c436",
	"./Nudes.webp": "f355",
	"./SwapTokenError.svg": "d8de",
	"./SwapTokenLoading.svg": "7f91",
	"./SwapTokenSuccess.svg": "7479",
	"./addresses.svg": "6830",
	"./allTimeTransactions.svg": "5afe",
	"./arrow-decrease.webp": "edce",
	"./arrow-down.svg": "2e6e",
	"./arrow-increase.webp": "7c96",
	"./arrow-up-order.svg": "187e",
	"./asterisk.svg": "0478",
	"./bNeo.webp": "6d1c",
	"./banner-gleede-mobile.svg": "0570",
	"./banner-gleede.svg": "b405",
	"./bg-gleeder-mobile.png": "5b23",
	"./bg-gleeder.png": "b51e",
	"./boomerang.svg": "2ef9",
	"./calculator.svg": "b643",
	"./caret-down.svg": "e40a",
	"./caret-left.webp": "8b28",
	"./caret-right-green-2.svg": "e84a",
	"./caret-right-green.svg": "68a7",
	"./caret-right-primary.svg": "d647",
	"./caret-right.svg": "ed41",
	"./caret-right.webp": "cbf1",
	"./caret-rotate.svg": "1c99",
	"./caret-up.svg": "53fe",
	"./carret-down.svg": "9c4a",
	"./carrot-swap.svg": "524e",
	"./check-circle.svg": "a7b6",
	"./check-icon.svg": "3a0d",
	"./check.svg": "6aa8",
	"./clock_icon.svg": "95ca",
	"./close-green.svg": "96a4",
	"./close.svg": "1d1b",
	"./coin-icon.svg": "3bac",
	"./coins-icon.svg": "e6e9",
	"./connected-icon.svg": "5305",
	"./connection-icon.svg": "0235",
	"./copy-icon.svg": "bad7",
	"./copy.svg": "87d1",
	"./copy.webp": "1ee8",
	"./deeplink-icon.svg": "52b3",
	"./desktop-icon.svg": "5c7c",
	"./disconnected-icon.svg": "8162",
	"./dora-icon.svg": "efbf",
	"./dora-logo.svg": "3eec",
	"./dora.svg": "b20f",
	"./down-arrow-circle.svg": "79d2",
	"./down-chevron.svg": "65c8",
	"./exit-icon.svg": "693d",
	"./expand-icon.svg": "b8f5",
	"./expand-more.svg": "c2cd",
	"./eye.svg": "9be9",
	"./facebook.webp": "aa5f",
	"./file-document.webp": "efdb",
	"./flamingo-icon.svg": "7f17",
	"./for-the-win-logo.svg": "bbb1",
	"./gas-calculator-page.svg": "4216",
	"./gas-icon-black.svg": "1e7d",
	"./gas.svg": "1b59",
	"./gas_rewards_icon.svg": "42a7",
	"./ghostmarket-icon.svg": "876d",
	"./github.svg": "6bff",
	"./glasses-icon.svg": "9be5",
	"./gleeder-desktop-banner.png": "0575",
	"./gleeder-icon.svg": "233a",
	"./gleeder-logo.svg": "ffc4",
	"./gleeder-mobile-banner.png": "63ab",
	"./google-plus.webp": "0866",
	"./hardware-icon.svg": "3603",
	"./icon-brench.svg": "e4c4",
	"./icon-code-lines.svg": "9f71",
	"./icon-commit.svg": "a40f",
	"./icon-contributors.svg": "9b04",
	"./icon-language.svg": "f330",
	"./icon-less.svg": "7cbd",
	"./icon-more.svg": "96e0",
	"./icon-organization-neo.webp": "5b55",
	"./icon-star.svg": "74f0",
	"./info-gray-icon.svg": "767d",
	"./info-icon-without-background.svg": "fae6",
	"./info-icon.svg": "b3c5",
	"./information.svg": "425c",
	"./laptop-icon.svg": "b959",
	"./left-chevron-green.svg": "38f1",
	"./linkedin.webp": "e5a7",
	"./lock.svg": "ad78",
	"./logo-ndapp.svg": "9440",
	"./logo-ndapp.webp": "16ea",
	"./logo.webp": "8e99",
	"./logout-icon.svg": "6d65",
	"./magnet-icon.svg": "af4d",
	"./menu-material.svg": "2e7a",
	"./my-nfts-icon.svg": "c479",
	"./my-tokens-icon.svg": "0463",
	"./n3statistics.svg": "8768",
	"./neo-bg-white.svg": "5ad8",
	"./neo-burger-simple.svg": "7abe",
	"./neo-burger.svg": "4260",
	"./neo-icon-green.svg": "aaea",
	"./neo-icon-white.svg": "db82",
	"./neo.svg": "c2f9",
	"./neo.webp": "e7d3",
	"./neoline.png": "fd87d",
	"./neonwallet.png": "d117",
	"./neoxstatistics.svg": "a21d",
	"./networkContracts.svg": "1d20",
	"./news.svg": "a1e0",
	"./not-available.png": "b7bb",
	"./one-gate.png": "43e5",
	"./pencil-icon.svg": "29095",
	"./percentage.svg": "9633",
	"./phone-icon.svg": "ddde",
	"./pinterest.webp": "413b",
	"./qrcode-icon.svg": "c101",
	"./recently-added.svg": "80d7",
	"./refresh.svg": "8d7e",
	"./right-arrow-long-primary.svg": "f777",
	"./search.svg": "6f6b",
	"./square-selected.svg": "cce5",
	"./swap-icon.svg": "49ed",
	"./swap.svg": "368e",
	"./terms-and-conditions-gasbot-image.webp": "198b",
	"./timer-icon.svg": "94af",
	"./tokens.svg": "3fdb",
	"./top-dapps.svg": "3579",
	"./top-nfts.svg": "278d",
	"./transactions.svg": "8291",
	"./ttm.webp": "df3d",
	"./twitter-x.webp": "3288",
	"./twitter.webp": "8815",
	"./wallet-icon-black.svg": "3e7c",
	"./wallet-icon-green.svg": "a943",
	"./wallet-icon.svg": "8c93",
	"./walletconnect-icon.svg": "1b0e",
	"./walletconnect.svg": "49f3",
	"./warning-icon.svg": "97c4",
	"./website-icon.svg": "3411"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";